import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  IInvoicePayments,
  IPaymentsList,
} from 'src/app/@interfaces/payments.interface';
import { startWith } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import {
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
  UntypedFormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { TransfersService } from './transfers.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PaymentsService } from '../crud-quotation/payments/payments.service';
import { AlertsService } from '../../services/alerts/alerts.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { AsyncPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-transfers',
  templateUrl: './transfers.component.html',
  styleUrls: ['./transfers.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class TransfersComponent implements OnInit, OnDestroy, OnChanges {
  dateForm: UntypedFormControl = this.fb.control(
    new Date(),
    Validators.required,
  );
  @Input() disable: boolean = false;
  @Input() payment = {} as IInvoicePayments;
  customTransferForm: UntypedFormGroup = this.fb.group({
    transferTo: ['', [Validators.required]],
    transferOf: ['', [Validators.required]],
    value: [
      0,
      [Validators.required, Validators.min(0.01), Validators.max(99999999.99)],
    ],
  });
  filteredOptionsTransferTo: Observable<IPaymentsList[]> | undefined;
  filteredOptionsTransferOf: Observable<IPaymentsList[]> | undefined;
  paymentsList: IPaymentsList[] = [];
  unsubscribe$ = new Subject<void>();
  constructor(
    private fb: UntypedFormBuilder,
    private transfersService: TransfersService,
    private spinnerService: NgxSpinnerService,
    private alertsService: AlertsService,
    private paymentsService: PaymentsService,
  ) {}

  ngOnInit(): void {
    this.paymentsTypeData();
    this.filterInputs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.payment?.currentValue!) {
      this.disableForms();
    }
  }

  disableForms() {
    if (this.disable) {
      this.customTransferForm.get('transferOf')?.disable({ onlySelf: true });
      this.setForms();
    }
  }

  setForms() {
    this.customTransferForm.patchValue({
      transferOf: this.payment.paymentType?.[0],
      value: this.payment.value,
    });
  }

  filterInputs() {
    this.filteredOptionsTransferTo = this.customTransferForm
      .get('transferTo')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this._filterP(value)),
      );
    this.filteredOptionsTransferOf = this.customTransferForm
      .get('transferOf')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this._filterP(value)),
      );
  }

  _filterP(value: string): IPaymentsList[] {
    const filterValueP = value.toString().toLowerCase();
    return this.paymentsList.filter((option) =>
      option.description.toLowerCase().toString().includes(filterValueP),
    );
  }

  displayFnPaymentType(payment: any) {
    return payment && payment ? payment.description : undefined;
  }

  registerCustom() {
    const transferTo = this.customTransferForm.value.transferTo;
    const transferOfRaw = !this.disable
      ? this.customTransferForm.value.transferOf
      : this.customTransferForm.get('transferOf')?.getRawValue();

    if (
      this.customTransferForm.invalid ||
      this.dateForm.invalid ||
      typeof transferTo !== 'object' ||
      !transferTo?.id_payment ||
      typeof transferOfRaw !== 'object' ||
      !transferOfRaw?.id_payment
    ) {
      this.alertsService.showErrorAlert(
        'Please, fill in all the required fields!',
      );
      return;
    }

    this.spinnerService.show();
    const date = this.dateForm.value;
    this.transfersService
      .createSimpleTransfer(
        this.payment ? 'Portfolio' : 'Custom',
        new Date(date).toDateString(),
        this.customTransferForm.value.value,
        this.payment ? parseInt(this.payment.id_payinvoice.toString()) : null,
        parseInt(transferOfRaw.id_payment),
        parseInt(transferTo.id_payment),
      )
      .then((confirm) => {
        this.spinnerService.hide();
        this.transfersService.validSuccessfullTransfers(
          [confirm],
          !this.disable,
        );
      })
      .catch((err) => {
        if (err !== false) this.spinnerService.hide();
      });
  }

  async paymentsTypeData() {
    const cashiersList = await this.paymentsService.getCashierList();
    const banksList = await this.paymentsService.getBankList();
    this.paymentsList = cashiersList.concat(banksList);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
